import { VerifyPaymentAnonymousResponse } from '@mindfulchefuk/forms/CardField/services/verifyPayments/verifyPayments.types'
import {
  ExternalPaymentsAnonymousTransaction,
  ExternalPaymentsTransaction,
} from '@mindfulchefuk/api-client'
import {
  CARD_FAILED_TEXT,
  CHECKOUT_ERROR,
} from '@mindfulchefuk/features/Notifications/constants'

interface CardAuthorisationCheck {
  status: string
  error_message: string
}

export const verifyPaymentAnonymous = async (
  checkoutSessionId: string
): Promise<VerifyPaymentAnonymousResponse> => {
  const { data } = await ExternalPaymentsAnonymousTransaction.where({
    cko_session_id: checkoutSessionId,
  }).first()

  if (!data) {
    throw new Error(CHECKOUT_ERROR)
  }

  const { error_message: errorMessage, status } = data as CardAuthorisationCheck

  if (status === 'failed') {
    throw new Error(errorMessage || CARD_FAILED_TEXT)
  }

  return { status }
}

export const verifyPayment = async (
  checkoutSessionId: string
): Promise<VerifyPaymentAnonymousResponse> => {
  const { data } = await ExternalPaymentsTransaction.where({
    cko_session_id: checkoutSessionId,
  }).first()

  if (!data) {
    throw new Error(CHECKOUT_ERROR)
  }

  const { status, error_message: errorMessage } = data as CardAuthorisationCheck

  if (status === 'failed') {
    throw new Error(errorMessage || CARD_FAILED_TEXT)
  }

  return { status }
}
